import * as LinkConvertedClickTargetType from "utils/Analytics/types/LinkConvertedClickTargetType";
import * as HotspotTargetType from "utils/HotspotTargetType";
import Tracker from "../Tracker";

export default function hotspotClick(options) {
  Tracker.sendHotspotLinkConverted({
    callbackIdentifier:
      options.targetType === HotspotTargetType.EXTERNAL_CALLBACK
        ? options.callbackIdentifier
        : null,
    chapterId: options.originationChapterId,
    clickTarget: LinkConvertedClickTargetType.HOTSPOT,
    cuepointId: `${options.originationChapterId} -> ${options.target}`,
    hotspotDuration: options.duration,
    hotspotStartTime: options.startTime,
    targetId: options.targetType === "chapter" ? options.target : null,
    targetUrl: options.targetType === "link" ? options.target : null,
    time: options.time,
    type: options.hotspotType,
  });
}
